/** Sponsor attribution: the `?ref=` a visitor arrived with, kept for the visit so signup still has it. */
const KEY = 'mp.ref';

export function captureRef(ref: string | null | undefined): void {
  if (!ref) return;
  try {
    sessionStorage.setItem(KEY, ref);
  } catch {
    /* private mode */
  }
}

export function storedRef(): string {
  try {
    return sessionStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}
